// extracted by mini-css-extract-plugin
export default {"root":"DocViewer_root__whU0Q","iframe":"DocViewer_iframe__rFBKW"};